import "../paymentLink/styles.css";
import CardDetailsForm from "../common/cardDetailsForm";
import CheckoutView from "./checkoutView";
import usePaymentLink from "../paymentLink/usePaymentLink";

const SaveCardV2 = ({
  handleChange, onSubmit, isLoading, isAllFieldsValid, merchantId, isCVVRequired }) => {
  const { merchantLogo } = usePaymentLink(null, null, merchantId);

  return (
    <CheckoutView
      onSubmit={onSubmit} 
      isLoading={isLoading}
      isAllFieldsValid={isAllFieldsValid}
      merchantLogo={merchantLogo}
      buttonLabel="Add Card"
      title="Enter card details">

        <CardDetailsForm
          handleChange={handleChange}
          isSaveCardOptionEnabled={false}
          isCVVRequired={isCVVRequired}
        />
    </CheckoutView>
  );
};

export default SaveCardV2;
